import type { MouseEvent, ReactNode } from 'react'
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined'
import TaActionButton from '../TaActionButton'
import { ICON_MD } from '../../common/theme'

interface BatchScoreButtonProps {
  // Number of questions the batch will act on (drives the tooltip).
  count: number
  // Total questions visible / available (e.g. when nothing is
  // selected, the batch defaults to "all"). Tooltip text changes
  // between "(N selected)" and "(all)" based on whether `count`
  // matches `total` or anything is selected.
  selectedCount?: number
  onClick: () => void
  disabled?: boolean
  icon?: ReactNode
  iconSize?: number
  sx?: any
  testId?: string
}

// Batch sibling of GenerateScoringButton — same visual (TaActionButton
// with the bar-chart icon) but fires a multi-question pmbatchprocess
// via the supplied onClick. Used by BidScoreTab's header so the
// batch-score action reads as the same affordance the user already
// knows from per-question rows.
export default function BatchScoreButton({
  count, selectedCount = 0, onClick, disabled, icon, iconSize, sx, testId,
}: BatchScoreButtonProps) {
  const title = selectedCount > 0
    ? `Estimate Score (${selectedCount} selected)`
    : count > 0 ? 'Estimate Score (all)' : 'Estimate Score'
  const handleClick = (e?: MouseEvent) => {
    e?.stopPropagation()
    onClick()
  }
  return (
    <TaActionButton
      title={title}
      onClick={handleClick}
      disabled={disabled || count === 0}
      icon={icon ?? <AssessmentOutlinedIcon sx={{ fontSize: ICON_MD }} />}
      iconSize={iconSize}
      sx={sx}
      testId={testId}
    />
  )
}
